import { MenuItem, Select } from '@mui/material';
import React from 'react';
import { AxisPreferences } from '../../config/plotTypes';

interface AxisMappingDropdownProps {
  value: string;
  axes: Record<string, AxisPreferences>;
  onChange: (value: string) => void;
}

export const AxisMappingDropdown: React.FC<AxisMappingDropdownProps> = ({
  value,
  axes,
  onChange,
}) => {
  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
      size="small"
      fullWidth
    >
      {Object.entries(axes).map(([axisKey, axisPrefs]) => (
        <MenuItem key={axisKey} value={axisKey}>
          {axisPrefs.displayName || axisKey}
        </MenuItem>
      ))}
    </Select>
  );
};
